import {useContext} from 'react';
import {Context} from '../context';

export function useClientUnsafe() {
  const {client} = useContext(Context);
  return client;
}